module.exports = __webpack_public_path__ + "img/ansible2.3bde1a29.png";